import React, { useState, useEffect, FC } from "react";
import toast from "react-hot-toast";
import {
  useWalletConnector,
  useAlgoSignerWalletConnector,
  useKeplrWalletConnector,
} from "./store";
import { WALLET_TYPES, cudosChainInfo } from "./walletConnectorInterfaces";
import { SigningCosmWasmClient } from "@cosmjs/cosmwasm-stargate";
import { StargateClient, accountFromAny } from "@cosmjs/stargate";

import Web3 from "web3";
import {
  useAccount,
  useConnect,
  useBalance,
  useConnectors,
  useChainId,
  useClient,
  useConnections,
  useDisconnect,
} from "wagmi";

export const useConnectivity = () => {
  // const { algoSignerLedger } = useFoundryProvider();
  const [isEligibleToConnect, setIsEligibleToConnect] =
    useState<boolean>(false);
  const { disconnect } = useDisconnect();
  const connections = useConnections();
  const client = useClient();
  const accounts = useAccount();
  const chainId = useChainId();
  const walletConnectBalance = useBalance();
  const { connectors, connect } = useConnect();

  // console.count("counting foundry render");
  // console.log({ isEligibleToConnect });
  const {
    rpcUrl,
    isConnecting,
    isConnected,
    web3Sdk,
    walletAddress,
    currentWallet,
    currentNetworkChainId,
    setRPCUrl,
    connectWallet,
    walletConnected,
    resetWalletConnector,
  } = useWalletConnector();

  // const {
  //   isAlgoConnected,
  //   algoSignerConnectWallet,
  //   algoSignerWalletConnected,
  //   resetAlgoSignerWalletConnector,
  // } = useAlgoSignerWalletConnector();

  const {
    connectedKeplrWalletAddress,
    keplrConnectWallet,
    keplrWalletConnected,
    resetKeplrWalletConnector,
  } = useKeplrWalletConnector();

  const { isKeplrConnected } = useKeplrWalletConnector();
  console.log({
    // rpcUrl,
    connections,
    client,
    chainId,
    accounts,
    account: accounts.address,
    chaindIdWagmi: accounts.chainId,
    walletConnectBalance,
    connectors,
    isConnecting,
    isConnected,
    walletAddress,
    currentWallet,
    currentNetworkChainId,
    web3Sdk,
  });

  // attempt to connect with metamask using wagmi
  // useEffect(() => {
  //   if (
  //     accounts.status === "connected" &&
  //     accounts.isConnected === true &&
  //     accounts.address &&
  //     accounts.chainId &&
  //     accounts.isConnecting === false &&
  //     !web3Sdk &&
  //     // rpcUrl &&
  //     (currentWallet === WALLET_TYPES.META_MASK ||
  //       currentWallet === WALLET_TYPES.WALLET_CONNECT)
  //   ) {
  //     console.log("attempt to wallet connect eagerly on mount walletconnect");
  //     reconnectToWallet(accounts.address, Number(accounts.chainId), rpcUrl);
  //   }
  // }, [isConnecting, accounts.isConnected, accounts.address, accounts.chainId]);

  //First wallet connect attempt
  // useEffect(() => {
  //   if (
  //     (accounts.isConnected === true &&
  //       accounts.address &&
  //       accounts.chainId &&
  //       accounts.isConnecting === false &&
  //       !web3Sdk &&
  //       rpcUrl &&
  //       currentWallet === WALLET_TYPES.WALLET_CONNECT) ||
  //     (isConnected &&
  //       walletAddress &&
  //       currentNetworkChainId &&
  //       !isConnecting &&
  //       web3Sdk &&
  //       rpcUrl &&
  //       currentWallet === WALLET_TYPES.WALLET_CONNECT)
  //   ) {
  //     // console.log("reconnecting 3");
  //     // console.log("After connecting setting state for connected metamask");
  //     // setIsEligibleToConnect(false);
  //     reconnectToWallet(
  //       Web3.utils.toChecksumAddress(accounts.address as any),
  //       Number(accounts.chainId),
  //       rpcUrl
  //     );
  //   } else if (isConnected && !accounts.address && accounts.chainId) {
  //     disconnect();
  //     resetWalletConnector();
  //   }
  //   // eslint-disable-next-line
  // }, [isConnecting, accounts.isConnected, accounts.address, accounts.chainId]);
  // wagmi metamask and wallet connect

  useEffect(() => {
    if (
      accounts.isConnected &&
      !isConnecting &&
      !web3Sdk &&
      isConnected &&
      accounts.address &&
      walletAddress &&
      accounts.chainId &&
      (currentWallet === WALLET_TYPES.META_MASK ||
        currentWallet === WALLET_TYPES.WALLET_CONNECT)
    ) {
      console.count("attempt to connect eagerly on mount metamask");
      reconnectToWallet(accounts.address, Number(accounts.chainId), rpcUrl);
    }
  }, [accounts.isConnected, isConnected]);

  useEffect(() => {
    console.log(
      "cond 1: ",
      accounts.isConnected === true &&
        isConnecting &&
        !isConnected &&
        accounts.address &&
        accounts.chainId &&
        accounts.isConnecting === false &&
        !web3Sdk &&
        (currentWallet === WALLET_TYPES.META_MASK ||
          currentWallet === WALLET_TYPES.WALLET_CONNECT)
    );
    console.log(
      "cond 2: ",
      isConnected && !accounts.address && !accounts.isConnected
    );
    console.log(
      "cond 3: ",
      accounts.isConnected === true &&
        isConnected &&
        ((accounts.address && accounts.address !== walletAddress) ||
          (accounts.chainId && accounts.chainId !== currentNetworkChainId)) &&
        accounts.isConnecting === false &&
        web3Sdk &&
        (currentWallet === WALLET_TYPES.META_MASK ||
          currentWallet === WALLET_TYPES.WALLET_CONNECT)
    );
    if (
      (accounts.isConnected === true &&
        isConnecting &&
        !isConnected &&
        accounts.address &&
        accounts.chainId &&
        accounts.isConnecting === false &&
        !web3Sdk &&
        (currentWallet === WALLET_TYPES.META_MASK ||
          currentWallet === WALLET_TYPES.WALLET_CONNECT)) ||
      (accounts.isConnected === true &&
        isConnected &&
        ((accounts.address && accounts.address !== walletAddress) ||
          (accounts.chainId && accounts.chainId !== currentNetworkChainId)) &&
        accounts.isConnecting === false &&
        web3Sdk &&
        (currentWallet === WALLET_TYPES.META_MASK ||
          currentWallet === WALLET_TYPES.WALLET_CONNECT))
    ) {
      reconnectToWallet(
        accounts.address as string,
        Number(accounts.chainId),
        rpcUrl
      );
    } else if (isConnected && !accounts.address && !accounts.isConnected) {
      disconnect();
      resetWalletConnector();
    }
    // eslint-disable-next-line
  }, [accounts.isConnected, accounts.address, accounts.chainId, isConnected]);

  const reconnectToWallet = async (
    account: string,
    chainId: number,
    rpcURL: string
  ) => {
    try {
      console.log("reconnectToWallet");
      const web3 = new Web3(client?.transport?.url);
      // console.log(web3);
      const balance = await web3.eth.getBalance(account);
      console.log("Balance", { balance });
      walletConnected(account, balance, chainId, web3);
    } catch (err: any) {
      console.log(err, "error here");
      resetWalletConnector();
      toast.error(err?.message);
    }
  };

  // const connectToMetaMaskWallet = async () => {
  //   console.log("connectToMetaMaskWallet");
  //   try {
  //     const accounts: any = await sdk?.connect();
  //     console.log(accounts);
  //     setIsEligibleToConnect(true);
  //   } catch (err) {
  //     console.warn(`failed to connect..`, err);
  //   }
  // };

  const connectMetaMask = async (connector: string) => {
    console.log("connectToMetaMask");
    try {
      const metaMaskConnector = connectors.find(
        (connector) => connector.name === "MetaMask"
      );
      if (metaMaskConnector) connect({ connector: metaMaskConnector });
    } catch (err) {
      console.warn(`failed to connect..`, err);
    }
  };

  const connectToWalletConnect = async (connector: string) => {
    console.log("connectToWalletConnect");
    try {
      const walletconnectConnector = connectors.find(
        (connector) => connector.name === "WalletConnect"
      );
      if (walletconnectConnector)
        connect({ connector: walletconnectConnector });
    } catch (err) {
      console.warn(`failed to connect..`, err);
    }
  };
  const connectToZerionWallet = async (connector: string) => {
    console.log("connectToZerionWallet");
    try {
      const zerionConnector = connectors.find(
        (connector) => connector.name === "Zerion"
      );
      if (zerionConnector) connect({ connector: zerionConnector });
    } catch (err) {
      console.warn(`failed to connect..`, err);
    }
  };

  // const connectToWalletConnect = async () => {

  //   console.log("connectToMetaMaskWallet");
  //   try {
  //     const connector = walletConnect({
  //       projectId: '3fbb6bba6f1de962d911bb5b5c9dba88',
  //     })
  //     console.log(connector)
  //   } catch (err) {
  //     console.warn(`failed to connect..`, err);
  //   }
  // };
  // const connectToWalletConnect = async () => {

  //   console.log("connectToMetaMaskWallet");
  //   try {
  //     const accounts: any = await connect(config, {
  //       connector: walletConnect({
  //         projectId: "3fcc6bba6f1de962d911bb5b5c3dba68",
  //       }),
  //     });
  //     console.log(accounts);
  //     setIsEligibleToConnect(true);
  //   } catch (err) {
  //     console.warn(`failed to connect..`, err);
  //   }
  // };
  // const connectToAlgoSignerWallet = (ledger: string) => {
  //   const { AlgoSigner } = window as any;
  //   if (AlgoSigner) {
  //     algoSignerConnectWallet(ledger);
  //     AlgoSigner.connect({
  //       ledger: ledger,
  //     })
  //       .then(async () => {
  //         let algorandPayload = {
  //           walletAddresses: [],
  //           web3Sdk: AlgoSigner,
  //         };
  //         algorandPayload.walletAddresses = await AlgoSigner.accounts({
  //           ledger: ledger,
  //         });
  //         if (!algorandPayload.walletAddresses.length) {
  //           toast.error("You do not have any account");
  //           resetAlgoSignerWalletConnector();
  //         }
  //         algoSignerWalletConnected(
  //           algorandPayload.walletAddresses,
  //           algorandPayload.web3Sdk
  //         );
  //       })
  //       .catch((error: any) => {
  //         toast.error(error);
  //         resetAlgoSignerWalletConnector();
  //       });
  //   } else {
  //     toast.error("AlgoSigner not found in your browser");
  //   }
  // };

  const connectKeplrWallet = async () => {
    const { keplr } = window as any;
    if (keplr) {
      // await keplr.experimentalSuggestChain(cudosChainInfo);
      await keplr.enable(cudosChainInfo.chainId);
      const offlineSigner = await keplr.getOfflineSigner(
        cudosChainInfo.chainId
      );
      const keplrAccounts = await offlineSigner.getAccounts();
      const CosmWasmClient = await SigningCosmWasmClient.connectWithSigner(
        cudosChainInfo.rpc,
        offlineSigner
      );
      const client = await StargateClient.connect(cudosChainInfo.rpc);
      const balanceAsCoin = await client.getBalance(
        keplrAccounts[0].address,
        cudosChainInfo.currencies[0].coinMinimalDenom
      );
      const balance =
        parseInt(balanceAsCoin.amount) /
        10 ** Number(cudosChainInfo.currencies[0].coinDecimals);
      keplrWalletConnected(
        keplrAccounts,
        cudosChainInfo.chainId,
        balance.toString(),
        CosmWasmClient
      );
    }
  };

  const walletConnectionHandler = (connector: WALLET_TYPES, rpcURL: string) => {
    // connection
    if (connector === WALLET_TYPES.META_MASK) {
      if (accounts.status === "connected" && accounts.isConnected === true) {
        console.log("disconnecting MetaMask");
        disconnect();
      } else {
        connectWallet(connector, rpcURL);
        connectMetaMask(WALLET_TYPES.META_MASK);
      }
    }
    // if (connector === WALLET_TYPES.META_MASK) {
    //   if (connected && isConnected) {
    //     console.log("disconnecting wallet metamask");
    //     sdk?.terminate();
    //     resetWalletConnector();
    //   } else if (connected && !isConnected) {
    //     sdk?.terminate();
    //     resetWalletConnector();
    //     connectWallet(connector, rpcURL);
    //     connectToMetaMaskWallet();
    //   } else {
    //     //connect to wallet
    //     connectWallet(connector, rpcURL);
    //     connectToMetaMaskWallet();
    //   }
    // }
    if (connector === WALLET_TYPES.WALLET_CONNECT) {
      if (accounts.status === "connected" && accounts.isConnected === true) {
        console.log("disconnecting WalletConnect");
        disconnect();
      } else {
        connectWallet(connector, rpcURL);
        connectToWalletConnect(WALLET_TYPES.WALLET_CONNECT);
      }
    }
    if (connector === WALLET_TYPES.ZERION) {
      if (accounts.status === "connected" && accounts.isConnected === true) {
        console.log("disconnecting ZerionWallet");
        disconnect();
      } else {
        connectWallet(connector, rpcURL);
        connectToZerionWallet(WALLET_TYPES.ZERION);
      }
    }
  };

  // const algoSignerWalletConnectionHandler = (ledger: string) => {
  //   if (isAlgoConnected) {
  //     resetAlgoSignerWalletConnector();
  //   } else {
  //     connectToAlgoSignerWallet(ledger);
  //   }
  // };

  const keplrWalletDisconnectionHandler = async () => {
    const { keplr } = window as any;
    if (!keplr) {
      toast.error("Keplr extension is not installed.");
      return;
    }
    await keplr.disable();
    resetKeplrWalletConnector();
  };

  const keplrWalletConnectionHandler = async () => {
    const { keplr } = window as any;
    if (!keplr) {
      toast.error("Keplr extension is not installed.");
      return;
    }
    if (connectedKeplrWalletAddress) {
      keplrWalletDisconnectionHandler();
    } else {
      keplrConnectWallet();
      connectKeplrWallet();
    }
  };

  return {
    setRPCUrl: (value: string) => setRPCUrl(value),
    walletConnectionHandler,
    connectKeplrWallet,
    keplrWalletDisconnectionHandler,
    keplrWalletConnectionHandler,
    // connectToAlgoSignerWallet,
    // algoSignerWalletConnectionHandler,
  };
};

// export function connectToWalletConnect() {
//   return <WalletOptions />;
// }

// function WalletOptions() {
//   const { connectors, connect } = useConnect();
//   return connectors.map((connector) => (
//     <WalletOption
//       key={connector.uid}
//       onClick={() => connect({ connector })}
//       connector={connector}
//     />
//   ));
// }
// function WalletOption({
//   connector,
//   onClick,
// }: {
//   connector: Connector;
//   onClick: () => void;
// }) {
//   const [ready, setReady] = React.useState(false);

//   React.useEffect(() => {
//     (async () => {
//       const provider = await connector.getProvider();
//       setReady(!!provider);
//     })();
//   }, [connector]);

//   return (
//     <button disabled={!ready} onClick={onClick}>
//       {connector.name}
//     </button>
//   );
// }
